module.exports = __webpack_public_path__ + "static/media/css.df2215ab.png";